export default __webpack_public_path__ + "static/media/img-b-result-distance-es_es@2x.00848339.jpg";